import {
  CreateFormTemplateQuestionDraft,
  CreateFormTemplateQuestionRequest,
  CreateFormTemplateRequest,
} from '../../models/TaskForm/TaskForm';

export const toCreateTemplateQuestionRequests = (
  questions: readonly CreateFormTemplateQuestionDraft[],
): CreateFormTemplateQuestionRequest[] =>
  questions.map(({ question, restriction }, index) => ({
    order: index + 1,
    question: question.trim(),
    restriction,
  }));

export const toCreateFormTemplateRequest = (
  name: string,
  questions: readonly CreateFormTemplateQuestionDraft[],
): CreateFormTemplateRequest => ({
  name: name.trim(),
  questions: toCreateTemplateQuestionRequests(questions),
});
